import { render, staticRenderFns } from "./FlowTriggerDetails.step.vue?vue&type=template&id=32d83920&scoped=true&"
import script from "./FlowTriggerDetails.step.vue?vue&type=script&lang=js&"
export * from "./FlowTriggerDetails.step.vue?vue&type=script&lang=js&"
import style0 from "./FlowTriggerDetails.step.vue?vue&type=style&index=0&id=32d83920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d83920",
  null
  
)

export default component.exports